/**
 * 新版商详页请求这里封装
 * 商详页改版（2022年7月）改版接口文档总结文档参考
 * https://docs.corp.kuaishou.com/d/home/fcABpIbo8DDsJge1hf1YvKqwQ
 */
import { request } from '@/services/index';

/**
 * 课程信息接口
 * https://mock.corp.kuaishou.com/project/1199/interface/api/909785
 ************************************************************************************/
export interface Res {
    data: any;
    error_msg: string;
    result: number;
    successful: boolean;
}

export interface CourseDetailCourse {
    courseId: number;
    // 课程的id
    name: string;
    // 课程的名称
    description: string;
    // 课程的描述
    coverImg: string;
    // 封面图
    courseType: string;
    // 课程类型，LIVE_ONLY - 直播课，VIDEO_ONLY - 视频课， FREE_VIDEO_ONLY - 免费课， OFFLINE_COURSE - 线下培训课， OFF_SITE_COURSE - 站外履约课站外课，GIFT_COURSE - 虚拟赠品课
    status: string;
    // 课程状态
    category: string;
    // 分类
    subCategory: string;
    // 子分类
    descImgUrls: string;
    // 课程详情页图片
    coverPhotoPlayUrl: string;
    // 宣传片
    coverPhotoId: string;
    // 宣传片的id
    serial: boolean;
    // 是否是连载课
    updateDeadline: number;
    // 连载课更新截止时间
    promiseUpdateLessonNum: number;
    // 连载课承诺更新课节数量
    complyStatus: string;
    // 连载课履约状态，ON_GOING 连载中、BREAK_PROMISE 未按时更完、COMPLETE 已更完
    lessonCount: number;
    // 课节数量
    free: boolean;
    // 是否是免费课
    supportLessonSale: boolean;
    // 是否支持单集购买
    courseCheckStatus: string;
    // 课程审核状态
    courseSellStatus: string;
    // 课程售卖状态
    newTrialPlayType: boolean;
    // 是否支持试看
    startTime: number;
    // 开始时间
    endTime: number;
    // 结束时间
    orderInfo: string[];
    // 站外课用的，不明白是干啥用的，，，
    learningPlatform: string[];
    // 站外课用的，学习平台
    teachingMode: string[];
    // 服务形式
    offSiteQAForm: string;
    // 服务时长
    offSiteQaDuration: number;
    // 是否能领取站外课
    contentAcquisitionMode?: number;
    // 表示不支持无理由退款
    notSupportRefundNoReason?: boolean;
    // 强制展示价格
    forceShowPrice?: boolean;
    // 强制展示购买按钮
    forceShowBuyButton?: boolean;
}
export interface CourseDetailLessons {
    lessonId: number;
    // 课节id
    name: string;
    // 课节名称
    index: number;
    // 课节编号
    coverImg: string;
    // 课节封面
    scheduledStartTime: number;
    // 直播课课节计划开始时间
    scheduledEndTime: number;
    // 直播课课节计划结束时间
    liveStartTime: number;
    // 直播开始时间
    liveEndTime: number;
    // 直播结束时间
    statusForTeacher: string;
    // 老师状态
    statusForStudent: string;
    // 学生状态
    liveStreamId: number;
    // 直播id
    realTime: number;
    // 时长
    trialTime: number;
    // 试看时长
    videoStatus: string;
    // 视频状态
    lessonType: string;
    // 视频类型，LIVE和VIDEO两个枚举
    bcursor: string;
    // 分页游标
    photoId: string;
    // 上下滑的photoId的base64
    pcursor: string;
    // 当前视频位置
}
export interface CourseDetailGifts {
    giftId: number;
    // 赠品id
    name: string;
    // 赠品名称
    description: string;
    //赠品详细描述
    giftImgUrls: string[];
}
export interface CourseDetailTags {
    tag: string;
    // 标签
    explaination: string;
    // 标签解释
}
export interface CourseDetailDistribution {
    canDistribute: boolean;
    // 课程能否被帮卖
    commissionRate: number;
    // 佣金比例
    commissionMaxPrice: number;
    // 最大佣金金额
    commissionMinPrice: number;
    // 最小佣金金额
}
export interface CourseDetail {
    canLiveTrial: boolean;
    // 直播课是否可以试看
    course: CourseDetailCourse;
    // 站外履约课购课学生需要填写的自定义信息
    courseCustomInfo: Record<string, string[]>;
    // 课程的总信息
    lessons: CourseDetailLessons[];
    // 课节的信息,如第一节课，第二节课
    gifts: CourseDetailGifts[];
    // 赠品课
    tags: CourseDetailTags[];
    // 权益
    courseDistribution?: CourseDetailDistribution;
    // 佣金相关信息
    nearestLesson: CourseDetailLessons;
    // 最近待直播的那堂课
    subscriberCount: number;
    // 课的销量 离线数据
    pageSize?: number;
    // 上下滑开关
    feedView?: boolean;
}
export const getCourseDetail = (param: {
    courseId: string;
    // 课程id
    channel?: string;
    // 渠道
    courseDistributionId?: string;
    // 帮卖者id
}) => {
    return request.post('/rest/lightks/wd/course/detail', param);
};

/**
 * 获取直播课的回放链接
 * https://mock.corp.kuaishou.com/project/1199/interface/api/499255
 ************************************************************************************/
export const getLiveExplainReplay = (param: {
    courseId: string;
    // 课程id
    courseDistributionId?: string;
    // 帮卖者id
}) => {
    return request.get(
        `/rest/lightks/wd/courses/liveExplainReplay?courseId=${param.courseId}`,
    );
};

/**
 * 获取课程价格信息接
 * https://mock.corp.kuaishou.com/project/1199/interface/api/499981
 ************************************************************************************/
export interface CourseTradeInfo {
    minKscoinPrice: number;
    // 最小快币价格
    maxKscoinPrice: number;
    // 最大快币价格
    maxPrice: number;
    // 最大人民币
    minPrice: number;
    // 最小人民币
    soldNumber: number;
    // 售卖数量
    number: number;
    // 商品的数量
    actualPrice: number;
    // 实际支付的价格
    showPriceType: string;
    // 展示价格的形式
}

// export const getTradeinfo = (param: {
//     courseId: string;
//     // 课程id
//     courseDistributionId?: string;
//     // 帮卖者id
// }) => {
//     return request.get(`/rest/lightks/wd/v2/course/trade/info?courseId=${param.courseId}`);
// };

/**
 * 获取用户角色相关信息
 * https://mock.corp.kuaishou.com/project/1199/interface/api/909810
 ************************************************************************************/
export interface GiftDeliveryInfo {
    deliveryCompany: string;
    // 快递公司
    deliveryOrderNo: string;
    // 快递单号
}
export interface UserRole {
    role: string;
    // 用户角色，包括：TEACHER,STUDENT,LESSON_STUDENT,VISITOR,
    hasAllCourseRight: boolean;
    // 是否具有观看整个课程的权益，他的优先级判断是高于lessonRights
    lessonRights: Record<string, boolean>;
    // key是lessonId, value表示是否具有课节的权益。
    useKscoinPay: boolean;
    // 是否使用快币支付
    orderId: string;
    // 订单id
    buttonOfRefund: string;
    // 退款按钮状态
    isSourceCourseStudent: boolean;
    // 是否是直播课的学生（直播转录播场景）
    needAgreePurchaseAgreement: boolean;
    // 是否签购买协议
    courseSubed: boolean;
    //是否关注免费课
    officialFollowed: boolean;
    // 是否关注官方账号
    joinGroup: boolean;
    // 是否可以加入群租
    needUpdatePhone: boolean;
    // 是否需要更新手机号
    giftDeliveryInfo: GiftDeliveryInfo;
    // 赠品物流信息list
    giftDeliveryInfoList: GiftDeliveryInfo[];
    newLessonNotices: number[];
    // 对用户来说是否是新课节小红点
    expandCourseNumber: boolean;
    // 对老师来说能否扩展学生数量
    sourceCourseId: number;
    // 当前用户是在帮卖黑名单内
    inDistributorBlackList: boolean;
    // 是否达到帮卖者门槛（粉丝和作品数达到要求）
    canBeDistributor: boolean;
    // 是不是正常的生产者
    isNormalTeacher: boolean;
    // 是否达到了生产者门槛
    canBeTeacher: boolean;
}

export const getUserRole = (courseId: string) => {
    return request.post(`/rest/lightks/wd/course/detail/user`, {
        courseId: courseId,
    });
};

/**
 * 获取课程评价相关信息
 * https://mock.corp.kuaishou.com/project/1199/interface/api/901272
 ************************************************************************************/
export interface DetailSelectedEvaluation {
    time: number;
    // 该评价的时间戳
    content: string;
    // 评价内容
    grade: string;
    // 提出评价的用户打分
    name: string;
    // 提出评价的用户昵称
    headImg: string;
    // 提出评价的用户昵称
}
export interface DetailEvaluation {
    evaluationGrade: number;
    // 评价级别
    evaluationScore: number;
    // 评价多少分
    totalCount: number;
    // 有多少人评价了
    selectedEvalutions: DetailSelectedEvaluation[];
    // 评论内容
    showEvaluationMinCount: number;
    // 至少要展示多少条评论
    canSelectGoodEvaluation: false;
    // 是否展示精选好评入口
}

export const getDetailEvaluation = (courseId: string) => {
    return request.post(`/rest/lightks/wd/course/detail/evaluation`, {
        courseId: courseId,
    });
};

/**
 * 获取老师的相关信息
 * https://mock.corp.kuaishou.com/project/1199/interface/api/901430
 ************************************************************************************/
export interface TeacherInfo {
    // 老师的名称
    name: string;
    // 老师id
    tid: number;
    // 老师的用户id
    ksUid: number;
    // 老师的头像
    headImg: string;
    // 老师介绍文案
    desc: string;
    // 售卖状况
    salesCount: number;
    // 老师状态
    status: string;
    // 老师账号是否异常相关
    teacherBanStatus: string;
    // 老师的认证信息
    certifications: {
        certificationDesc: string;
        certificationIconUrl: string;
    }[];
}

export const getTeacherInfo = (courseId: string) => {
    return request.post(`/rest/lightks/wd/course/detail/teacher`, {
        courseId: courseId,
    });
};

/**
 * 获取课程价格信息接口，包括优惠券
 * https://mock.corp.kuaishou.com/project/1199/interface/api/901430
 ************************************************************************************/
export interface CourseTradeInfo {
    actualPrice: number;
    // 实际支付的价格
    maxKscoinPrice: number;
    // 最大快币价格
    maxPrice: number;
    // 最大人民币
    minPrice: number;
    // 最小人民币
    minKscoinPrice: number;
    // 最小快币支付额
    number: number;
    // 商品的数量（库存）, -1代表无限制
    soldNumber: number;
    // 售卖数量
    unitPrice: number;
    // 售卖价格
    recommendedCombinationVoucherList: VoucherList[];
    // 已领取的券中，最优的减免方式，（因为用户存在同时拥有多种优惠券的情况、那种减免方式是最划算的会通过这个字段返回）
    voucherList: VoucherList[];
    // 没有领过券的优惠券列表，voucherInfo是老数据，要干掉的
    skuList: VoucherList[];
    // 这个是期约课用的，比如30天有效期、永久有效、不同有效期售卖价格不一样，当只有skuList的length > 1的时候
    secKillInfoDTO?: {
        secKillId: number;
        // 秒杀id
        courseId: number;
        // 课的id
        secKillPrice: number;
        // 秒杀价格
        secKillStartTime: number;
        // 秒杀活动开始时间
        secKillEndTime: number;
        // 秒杀活动结束时间
        currentTime: number;
        // 活动id
        activityId: number;
        // 活动类型
        activityType: string;
    };
}
export interface TradeInfoLessonTradeInfoMap {
    actualPrice: number;
    // 实际支付的价格
    maxKscoinPrice: number;
    // 最大快币价格
    maxPrice: number;
    // 最大人民币
    minKscoinPrice: number;
    // 最大快币价格
    minPrice: number;
    // 最小人民币
    number: number;
    // 商品的数量（库存）, -1代表无限制
    recommendedCombinationVoucherList: VoucherList[];
    skuList: VoucherList[];
    soldNumber: number;
    // 销售量
    unitPrice: number;
    // 单品价格，原来的价格
}
export interface VoucherList {
    commodityId: number;
    // 商品id
    activityId: number;
    // 活动id
    discountType: number;
    // 折扣类型 1:全额抵扣 最小金额支付 2:现金抵扣 比如满10-2 3:折扣，比如8折券
    discountValue: number;
    // 折扣，例如八折即80%, discountValue = 80，或是对应”满xxx减yyy“的xx
    bearerType: number;
    // 1是平台券，2是店铺券
    received: boolean;
    // 是否已领取
    expireTime: number;
    // 失效时间
    title: string;
    // 优惠券名字
    voucherId: number | null;
    // 券的id，需要关注这个，配合平台类型使用,如果用户没有领取，则是null
    promotionPlatform: number;
    // 平台，标识来源是我们的后台还是小店商家券 1:课堂自有优惠券 2:小店营销工具
    bearerId: number | null;
    // 前端无需关注
    useScopeType: number;
    // 适用范围 现在线上有用的 1:商品券 5:平台券 6:店铺券 7:营销券
    kscoinDiscountValue: number;
    // 对应”满xxx减yyy“的xx，快币方式
    minimumOrderPrice: number;
    // 对应”满xxx减yyy“的xx，人民币方式的
    minimumPayPrice: number;
    // minimumPayPrice
    kscoinMinimumOrderPrice: number;
    // 对应”满xxx减yyy“的xx， 快币方式的
    kscoinMinimumPayPrice: number;
    // 快币最小实际支付金额
    leftStock: null;
    // 活动剩余库存
    activityStatus: string | null;
    // 活动状态，看到的应该都是running，INIT初始态，RUNNING已启用，FINISHED已结束，CANCELLED已取消，
    showBearerTypeFlag?: boolean;
    // 前端自己定义的变量，用于记录是否商家券||平台券标签
    voucherWriter?: string;
    // 前端自己定义的变量，用于记录券的文案
}
export interface TradeInfo {
    courseTradeInfo: CourseTradeInfo;
    // 课程的交易信息
    lessonTradeInfoMap: Record<string, TradeInfoLessonTradeInfoMap>;
    // 课节的交易信息
    voucherList: VoucherList[];
    // 没有领过券的优惠券列表，voucherInfo是老数据，要干掉的
}
/**
 * 商详页sku列表的选项
 */
export interface SkuListItem {
    id: number;
    cid: number;
    imgKey: string;
    imgUrl: string;
}
/**
 * 商详页skuList的接口返回
 */
export interface SkuListResult extends Res {
    data: SkuListItem[];
}

export const getTradeInfo = (param: {
    courseId: string;
    // 课程id
    courseDistributionId?: string;
    // 帮卖者id
}) => {
    return request.get(
        `/rest/lightks/wd/v2/course/trade/info?courseId=${param.courseId}`,
    );
};

/**
 * 支付下单前置接口-获取用户余额等信息
 * https://mock.corp.kuaishou.com/project/1199/interface/api/189069
 ************************************************************************************/
export interface OrdersPrepay {
    userBalance: number;
    // 用户余额
    userStatus: number;
    // 用户状态 UNKNOWN = 0 默认值, 理论上不会返回； NORMAL = 1 正常状态； FROZEN = 2 冻结状态;
    useKscoinPay: boolean;
    // 是否使用 快币支付
    payCounterUrl: string;
    // 收银台回调 url
    relatedId: number;
    // course、lesson id 根据下面的commodityType字段区分
    commodityType: number;
    // 商品类型 1 course 2 lesson
    commodityName: string;
    // 商品名称
    userBanned: boolean;
    // 用户是否被禁用
}
export const getOrderPrepayInfo = () =>
    request.post(`/rest/lightks/wd/orders/prepay`);

/************************************************************************************
 * 获取快币充值列表接口
 * https://mock.corp.kuaishou.com/project/1199/interface/api/249105
 ************************************************************************************/
export interface KsCoinIapItem {
    id: number;
    name: string;
    // 条目名称
    yDou: number;
    // 快币数
    fen: number;
    // 对应人民币金额
    dollar: string;
    // 对应美元金额
    couponFen: number;
    // 代金券金额
    couponYDou: number;
    // 代金券快币数
}
export const getKsCoinIapList = () =>
    request.post(`/rest/lightks/wd/orders/kscoin/iapitem`);

export interface ProductType {
    name: string;
    vouchers: VoucherList[];
    price: number;
    originPrice?: number;
    lessonId: number;
    courseId: number;
    discount?: number;
}

/**
 * 关注官方账号
 */
export const followUser = (touid: string | number) =>
    request.post('https://apissl.gifshow.com/rest/wd/relation/follow', {
        touid,
        ftype: 1,
        page_ref: '60',
    });

/**
 * 取消报名免费课程
 * @param courseId
 */
export const unsubscribeFreeCourse = (courseId) =>
    request.post(`/rest/lightks/wd/freeCourse/unSub`, {
        courseId,
    });

/**
 * 报名免费课程
 * @param courseId 课程id
 */
export const subscribeFreeCourse = (courseId) =>
    request.post(`/rest/lightks/wd/freeCourse/sub`, {
        courseId,
    });

// 增长业务提的需求，用于判断是否拉起邀请新用户接口
export interface TaskState {
    // 主文案
    mainTitleOfButton: string;
    // 副文案
    subtitleOfButton: string;
    // 强样式入口的标题
    activityTitle: string;
    // 强样式入口的描述文案
    activityDescription: string;
    // 活动的链接
    activityUrl: string;
    // 活动id
    taskId: number;
    // 是否展示入口
    showActivity: boolean;
}

export async function getInviteTaskState(courseId: number) {
    return await request.get(
        `/rest/lightks/wd/courses/detail/inviteTaskState?courseId=${courseId}`,
    );
}

/**
 * 获取课程评价信息
 * @param courseId 课程id
 */
export const getCourseEvaluationStatus = async (courseId: number) => {
    return await request.post(
        `/rest/lightks/wd/courses/courseEvaluationStatus`,
        {
            courseId,
        },
    );
};

/**
 * 提交课程评价
 * @param params
 * params.courseId number
 * params.evaluate string
 * params.content string
 * params.tags string[]
 */
export async function evaluateCourse(params) {
    return await request.post(`/rest/lightks/wd/evaluate/course`, params);
}

/**
 * 加入主播群聊
 * @param courseId
 */
export async function joinGroup(courseId) {
    return await request.post(`/rest/lightks/wd/courses/joinGroup`, {
        courseId,
    });
}

/**
 * 优惠券领取接口
 * @params [{activityId: number, promotionPlatform: 1}]
 * https://mock.corp.kuaishou.com/project/1199/interface/api/500206
 */
// 领取优惠券
export function receiveCoupons(params) {
    return request.post(`/rest/lightks/wd/voucher/batchIssue`, params);
}

/**
 * 最近购买的学生，用于直播课给老师展示有哪些学生买了课
 */
export interface DetailRecentItem {
    headImg: string;
    name: string;
    time: number;
    sex: string;
    userId: number;
}
export interface DetailRecent {
    recentUsers: DetailRecentItem[];
}
export function getRecentUsers(params) {
    return request.post(`/rest/lightks/wd/course/detail/subscribers`, params);
}
// 站外履约课的图文描述-教学形式
export const TeachingMode = {
    ONLINE_LIVING: '线上直播',
    ONLINE_VIDEO: '线上录播',
    OFFLINE: '线下学习',
};

// 站外履约课的图文描述-教学平台
export const LearningPlatform = {
    ONLINE: '站外平台线上学习',
    OFFLINE: '线下学习',
};

// 站外履约课的图文描述-服务形式
export const OffSiteQaForm = {
    ONE_ONE: '提供一对一服务',
    ONE_MORE: '提供一对多服务',
    NOT_PROVIDED: '不提供课程内容咨询答疑服务',
};
// 站外履约课的图文描述-服务形式
export const OffSiteQaDuration = (i: number) => {
    if (i === 0) {
        return '少于1个月';
    } else if (i === -1) {
        return '大于12个月';
    } else {
        return `${i}个月`;
    }
};

/**
 * 删除小红点
 */
export const delNotice = ({
    noticePlace,
    noticeRelatedId = '',
}: {
    noticePlace: number;
    noticeRelatedId?: string;
}) => {
    const params: {
        noticePlace: number;
        noticeRelatedId?: string;
        noticeType: 1;
    } = {
        noticeType: 1,
        noticePlace,
    };
    if (noticeRelatedId) {
        params.noticeRelatedId = noticeRelatedId;
    }
    return request.post(`/rest/lightks/wd/notice/del`, params);
};

/**
 * 获取客服url
 */
export const getCustomerServiceUrl = () => {
    return request.post(
        'https://csc.m.kuaishou.com/rest/csc/center/url/get',
        {
            entranceId: 1196,
        },
        {
            withCredentials: false,
        },
    );
};

function CustomServiceClosure() {
    let url = '';
    return async function getUrl(): Promise<string> {
        if (url) {
            return url;
        }
        const { data } = await getCustomerServiceUrl();
        url = data;
        return url;
    };
}

export default CustomServiceClosure();

/**
 * 复购
 * https://mock.corp.kuaishou.com/project/1199/interface/api/966523
 */
export interface RecommendList {
    id: number;
    name: string;
    coverImg: string;
    useKsCoinPay: false;
    price: number;
    discountLabel: number; // 1:秒杀 2:优惠券
    discountPrice: number; // 折扣价
    subscriberCount: number | string; // 已购数量
    discountKsCoinPrice: string;
    ksCoinPrice: string;
    link: string;
}
export interface RecommendMore {
    nickName: string;
    headImg: string;
}
export const getRecommendList = (courseId: number) => {
    return request.post(`/rest/lightks/wd/courses/recommendList`, {
        courseId: courseId,
    });
};

/**
 * 复购-不同作者的
 */
export interface RecommendListOtherTeachers {
    recommendList: RecommendList[];
    pcursor: string;
}
export const getRecommendListOtherTeachers = (param) => {
    return request.post(
        `/rest/lightks/wd/courses/recommendList/otherTeachers`,
        param,
    );
};

/**
 * 首屏接口
 * https://mock.corp.kuaishou.com/project/1199/interface/api/991841
 */
export const getCourseBrief = (param: {
    courseId: string;
    // 课程id
    channel?: string;
    // 渠道
    courseDistributionId?: string;
    // 帮卖者id
}) => {
    return request.post(`/rest/lightks/wd/course/brief`, param);
};

// 获取联系商家的联系链接
export const getImEntranceInfo = (courseId) => {
    return request.get(
        `/rest/lightks/wd/im/imEntranceInfo?fromPage=1&courseId=${courseId}`,
    );
};

// 查询分销/推荐账号的绑定信息
export const getDistributorBindInfo = () => {
    return request.post(`/rest/lightks/wd/dist/distributor/access/query`);
};
enum DistributionStatus {
    /**
     * 帮卖中
     */
    Active = 1,
    /**
     * 已下架,暂停帮卖,帮卖者主动下架帮卖
     */
    Offline = 2,
    /**
     *  审核中
     */
    Auditing = 3,
    /**
     * 被生产者拒绝
     */
    Rejected = 4,
    /**
     * 被生产者取消合作
     */
    Canceled = 5,
    /**
     * 原课程被下架
     */
    CourseOffline = 6,
    /**
     * 包括 帮卖课程到期 和 帮忙课程被生产者关闭
     */
    CourseExpired = 7,
}
export interface MyDistributionStatus {
    // 是否允许创建 true 标示用户未申请或申请被拒绝但可以再次发起申请，如果用户已经在申请中则此时 canApply=false
    canApply: boolean;
    // 是否有申请记录
    exists: boolean;
    // 状态
    status: DistributionStatus | null;
}

// 获取用户申请分销/帮卖/推荐状态
export const getDistributionStatus = (courseId: string) => {
    return request.post(
        `/rest/lightks/wd/course/detail/distribution/relation/status`,
        {
            courseId,
        },
    );
};

// 申请分销/帮卖/推荐
export const fixApplyDistribution = (courseId: string) => {
    return request.post(`/rest/lightks/wd/dist/distributor/relation/apply`, {
        courseId,
    });
};
// 获取分销/帮卖/推荐者信息
export const getDistributorInfo = (
    distributionId: string,
    courseId: string,
) => {
    return request.post('/rest/lightks/wd/course/detail/distribution/info', {
        relationId: distributionId,
        courseId,
    });
};
// 获取课程详情页SKU选项
export const getSkuList = (courseId: string): Promise<SkuListResult> => {
    return request.post(`/rest/lightks/wd/api/course/detail/skuList`, {
        courseId,
    });
};

export interface ContentAcquisitionResult {
    data: {
        contentAcquisitionMode: number;
        qrCodeImgKeys?: string[];
        qrCodeImgUrls?: {
            [k in string]: string[];
        };
        contentAcquisitionURL?: string[];
    };
}
// 获取站外课履约方式
export const getContentAcquisition = (
    courseId: string,
): Promise<ContentAcquisitionResult> => {
    return request.post(
        `/rest/lightks/wd/product/course/offSite/getContentAcquisition`,
        {
            courseId,
        },
    );
};

// 英雄榜&充电节-用户活动信息
export interface baseResult {
    result: number;
    data: any;
    error_msg: string;
    successful: boolean;
}

export interface trackInfoDTOListType {
    index?: number;
    id: number;
    track: string;
    title: string;
    subTitle: string;
    minGvmTargetValue: string | null;
}
export interface ActivitiesType {
    activityId: number;
    title: string;
    desc: null;
    startTime: number;
    endTime: number;
    awardIssue: string | null;
    status: number;
    trackInfoDTOList: trackInfoDTOListType[];
}

export interface HeroAndPowerInfo {
    showEnter: true;
    activities: ActivitiesType[];
    startTime: number;
    endTime: number;
}
export interface HeroAndPowerInfoResType extends baseResult {
    data: HeroAndPowerInfo;
}

export const heroAndPowerInfo = async (): Promise<HeroAndPowerInfoResType> => {
    return request.get('/rest/lightks/wd/activity/heroAndPower/info');
};

/** 充电节消费者分享任务 */
export const userForwardTaskAward = async (courseId: number): Promise<Res> => {
    return request.post('/rest/lightks/wd/activity/hero/task/userForward', {
        courseId,
    });
};
